export const siteName = "妖精动漫";

export const navLinks = [
  { label: "入口总览", href: "#entries" },
  { label: "最新地址", href: "#address" },
  { label: "APP下载", href: "#app" },
  { label: "官网识别", href: "#verify" },
  { label: "访问排查", href: "#troubleshoot" },
  { label: "常见问题", href: "#faq" },
];

export const heroStats = [
  { value: "3 类", label: "官网 / APP / 最新地址" },
  { value: "多端", label: "手机与电脑均可访问" },
  { value: "4 步", label: "按指引完成访问" },
  { value: "持续", label: "入口信息长期维护" },
];

export const entryCards = [
  {
    icon: "ri-global-line",
    tag: "网页端",
    title: "官网入口",
    desc: "直接在浏览器打开，无需安装即可浏览。适合临时查看、分享给朋友，或在新设备上快速进入。",
    points: ["无需安装、打开即用", "支持电脑与手机浏览器", "建议加入书签长期保存"],
    accent: "primary",
  },
  {
    icon: "ri-smartphone-line",
    tag: "客户端",
    title: "APP 客户端",
    desc: "安装客户端后访问更稳定，阅读记录与收藏可在同一账号下同步，日常使用更顺手。",
    points: ["安卓 / iOS / 电脑端均可", "登录后收藏可同步", "打开速度快、体验更稳定"],
    accent: "accent",
  },
  {
    icon: "ri-links-line",
    tag: "地址",
    title: "最新地址",
    desc: "当旧链接无法打开时，需要重新获取当前可用地址。请以官方发布的地址为唯一依据。",
    points: ["旧链接失效时更换", "以官方公布为准", "同时保留多个备用入口"],
    accent: "secondary",
  },
];

export const addressSteps = [
  {
    step: "01",
    title: "认准官方发布渠道",
    desc: "最新地址只会通过官方页面、官方公告等渠道发布。请勿相信来历不明的群消息或第三方跳转页，避免进入仿冒站点。",
  },
  {
    step: "02",
    title: "核对地址是否被更换",
    desc: "若原收藏链接长时间打不开，通常是地址已更新。此时不要反复刷新旧链接，而是回到官方渠道确认当前地址。",
  },
  {
    step: "03",
    title: "保存多个备用入口",
    desc: "把官方页面加入书签，并另存一份到备忘录或笔记工具。多个备份能在一处失效时立刻切换到另一处。",
  },
  {
    step: "04",
    title: "定期回访确认更新",
    desc: "把本站或官方页面加入收藏夹，隔一段时间回来看看公告，即可第一时间知道地址是否有变动。",
  },
];

export const appPlatforms = [
  {
    key: "android",
    name: "安卓手机",
    icon: "ri-android-line",
    summary: "适合绝大多数安卓机型，安装步骤简单，是使用比例最高的方式。",
    steps: [
      "在官方渠道下载最新的安装包文件（APK）。",
      "下载完成后，在文件管理里点击安装包启动安装。",
      "若系统提示「未知来源应用」，请在设置中临时允许安装。",
      "安装完成打开客户端，按引导登录或注册即可使用。",
    ],
    tips: ["只从官方渠道获取安装包", "安装前可先关闭旧版本以避免冲突"],
  },
  {
    key: "ios",
    name: "iPhone / iPad",
    icon: "ri-apple-line",
    summary: "苹果设备获取方式与安卓不同，通常需要按官方说明的对应方法来安装。",
    steps: [
      "先打开官方页面，查看当前苹果设备的获取说明。",
      "按照页面指引完成安装或添加到主屏幕。",
      "首次打开如出现安全提示，请按系统说明确认后继续。",
      "登录官方账号后即可同步收藏与观看记录。",
    ],
    tips: ["优先阅读官方针对 iOS 的说明", "保持系统版本在主流区间更稳定"],
  },
  {
    key: "desktop",
    name: "电脑端",
    icon: "ri-computer-line",
    summary: "不便安装客户端时，直接用电脑浏览器访问官网即可，无需额外下载。",
    steps: [
      "用 Chrome、Edge 等主流浏览器打开官方网址。",
      "将页面添加到书签栏，方便下次一键打开。",
      "如页面显示异常，可尝试清理缓存或更换浏览器。",
      "需要更大屏幕体验时，可切换全屏浏览模式。",
    ],
    tips: ["使用较新版本的浏览器", "关闭拦截类插件以获得正常显示"],
  },
];

export const verifyPoints = [
  {
    icon: "ri-shield-check-line",
    title: "核对域名拼写",
    desc: "仿冒站常通过多一个字母、换一个后缀来混淆。进入前请逐字核对域名，确认与官方公布的一致。",
  },
  {
    icon: "ri-megaphone-line",
    title: "查看官方公告",
    desc: "真正的官方页面通常有稳定的公告区域，用于说明地址变动与服务状态，而不是频繁跳转的临时页。",
  },
  {
    icon: "ri-lock-password-line",
    title: "留意登录环节",
    desc: "官方登录流程清晰规范。若页面要求输入与平台无关的信息，或频繁弹出陌生下载，请立即关闭。",
  },
  {
    icon: "ri-error-warning-line",
    title: "警惕强制弹窗",
    desc: "仿冒站常用弹窗、倒计时、强制下载等方式诱导操作。遇到这类明显干扰，应优先判断为风险页面。",
  },
  {
    icon: "ri-file-shield-2-line",
    title: "避免重复下载",
    desc: "官方不会要求反复安装多个来源不明的程序。安装包只需从一个可信来源获取一次即可。",
  },
  {
    icon: "ri-history-line",
    title: "从收藏回访",
    desc: "养成从自己的书签或本站指引回访的习惯，而不是点击聊天群里随时可能失效的短链接。",
  },
];

export const troubleshootItems = [
  {
    icon: "ri-wifi-off-line",
    title: "页面打不开或一直转圈",
    desc: "先确认地址是否为最新，再尝试切换网络（如 Wi-Fi 与移动数据互换），多数情况下可以恢复。",
  },
  {
    icon: "ri-refresh-line",
    title: "内容加载不出来",
    desc: "清理浏览器缓存后重新打开，或换用另一个浏览器测试，可排除缓存过期导致的显示问题。",
  },
  {
    icon: "ri-timer-line",
    title: "高峰时段访问缓慢",
    desc: "晚间等高峰时段访问人数较多，加载可能变慢。可稍后重试，或改用客户端访问以获得更稳定的体验。",
  },
  {
    icon: "ri-plug-line",
    title: "插件或安全软件拦截",
    desc: "部分广告拦截、脚本拦截插件会误拦正常内容。可临时关闭相关插件，或将官方地址加入信任列表。",
  },
  {
    icon: "ri-device-line",
    title: "新设备无法登录",
    desc: "确认账号密码无误，并检查输入法是否输错字符。若仍失败，可通过官方渠道的说明进行处理。",
  },
  {
    icon: "ri-question-line",
    title: "不确定地址是否有效",
    desc: "不要凭记忆拼写地址。回到官方页面或本站指引重新获取，是最稳妥的做法。",
  },
];

export const featureItems = [
  {
    icon: "ri-folders-line",
    title: "分类清晰",
    desc: "按题材、地区、更新时间等维度组织内容，找片更省时间，不必在大量列表里反复翻找。",
  },
  {
    icon: "ri-hd-line",
    title: "画质可选",
    desc: "根据网络情况在清晰度之间切换，兼顾画面与流畅度，弱网环境下也能顺畅浏览。",
  },
  {
    icon: "ri-calendar-check-line",
    title: "更新提示",
    desc: "关注的条目更新后能快速看到变化，避免反复手动检查，节省追更时间。",
  },
  {
    icon: "ri-bookmark-3-line",
    title: "收藏同步",
    desc: "登录账号后，收藏与观看记录在多端同步，换设备也不用重新整理一遍。",
  },
  {
    icon: "ri-search-eye-line",
    title: "搜索便捷",
    desc: "支持关键词检索，配合筛选条件能更快定位想看的条目，减少无效浏览。",
  },
  {
    icon: "ri-moon-clear-line",
    title: "夜间友好",
    desc: "界面可适配较暗的观看环境，长时间浏览时更护眼，体验更舒适。",
  },
];

export const starterSteps = [
  {
    step: "1",
    title: "打开官方入口",
    desc: "通过官方页面或本站指引进入，确认地址无误后再继续。",
  },
  {
    step: "2",
    title: "选择使用方式",
    desc: "想随时用手机就安装客户端；只是偶尔看看，直接用浏览器访问即可。",
  },
  {
    step: "3",
    title: "登录并同步",
    desc: "登录账号后，收藏与记录会自动保存，换设备也能接着看。",
  },
  {
    step: "4",
    title: "保存并回访",
    desc: "把入口加入书签，并在地址变动时及时更新，保持长期可用。",
  },
];

export const faqs = [
  {
    q: "妖精动漫的官网到底怎么找，才不会被带到假站？",
    a: "核心是「以官方发布为准」。不要凭记忆拼写地址，也不要点陌生群消息里的短链接。进入前先核对域名拼写是否与官方公布的一致，并留意页面是否有稳定公告区域、登录流程是否规范。遇到强制下载、倒计时弹窗等明显干扰，应马上关闭。",
  },
  {
    q: "收藏的旧链接打不开了，是停用了吗？",
    a: "多数情况是地址发生了更新，而不是服务停用。这时不要反复刷新旧链接，而是回到官方渠道查看当前可用地址，然后把新地址重新加入书签。建议同时保留两到三个备用入口，方便切换。",
  },
  {
    q: "APP 和网页版该选哪个？",
    a: "如果经常用手机看，安装客户端体验更稳定，收藏和记录也能同步；如果只是偶尔查看或在使用别人的设备，直接用浏览器访问官网更方便，无需安装。两者并不冲突，可以按场景选择。",
  },
  {
    q: "在多个设备上登录，收藏会丢吗？",
    a: "只要使用同一个账号登录，收藏与观看记录通常会随账号同步，换设备后重新登录即可看到。若发现不同步，先确认登录的账号是否一致，再尝试重新登录一次。",
  },
  {
    q: "页面加载很慢或者干脆打不开怎么办？",
    a: "先确认地址是否为最新，再按顺序排查：切换网络、清理浏览器缓存、更换浏览器。高峰期访问变慢属于正常现象，可以稍后重试，或改用客户端以获得更稳定的连接。",
  },
  {
    q: "安装客户端时提示安全风险，正常吗？",
    a: "部分系统对非应用商店来源的安装包会给出提示，这是系统的常规提醒。关键是要确保安装包来自官方渠道，而不是第三方转载页。来源不明时请勿安装，回到官方页面重新获取。",
  },
];